import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	oneFieldDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multipleFieldsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	affectedVersion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fixVersion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueCountIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	multipleFieldsDescriptionIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	oneFieldDescription: {
		id: 'project-directories.versions.delete-version.content.one-field-description',
		defaultMessage: 'Deleting this version will remove it from {issueCountLink}.',
		description: '',
	},
	issueCount: {
		id: 'project-directories.versions.delete-version.content.issue-count',
		defaultMessage: '{count} {count, plural, one {issue} other {issues}}',
		description: '',
	},
	multipleFieldsDescription: {
		id: 'project-directories.versions.delete-version.content.multiple-fields-description',
		defaultMessage:
			'A few issue fields reference {name}. You can update the fields to reference another version or clear the value of those fields.',
		description: '',
	},
	affectedVersion: {
		id: 'project-directories.versions.delete-version.content.affected-version',
		defaultMessage: 'Affects version',
		description: '',
	},
	fixVersion: {
		id: 'project-directories.versions.delete-version.content.fix-version',
		defaultMessage: 'Fix version',
		description: '',
	},
	issueCountIssueTermRefresh: {
		id: 'project-directories.versions.delete-version.content.issue-count-issue-term-refresh',
		defaultMessage: '{count} {count, plural, one {work item} other {work items}}',
		description: '',
	},
	multipleFieldsDescriptionIssueTermRefresh: {
		id: 'project-directories.versions.delete-version.content.multiple-fields-description-issue-term-refresh',
		defaultMessage:
			'A few fields in the work item reference {name}. You can update the fields to reference another version or clear the value of those fields.',
		description: '',
	},
});
export default messages;
